import ClientOnly from "@hl/base-components/lib/ClientOnly";
import { ArrowLeft } from "@hl/base-components/lib/assets/icons/HDS";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { lightTheme } from "@hl/base-components/lib/theme/light/theme";
import { Box, Button, MantineProvider, Stack } from "@mantine/core";
import { Link, useParams } from "react-router-dom";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "~/../../shared-features/lib/features/auth/hooks";
import { AppSEO } from "~/../../shared-features/lib/features/layout";

import { TOOLS_URL } from "config";

import { CurationBuilder } from "./builder/CurationBuilder";
import { BUILDER_VERSION } from "./builder/utils";
import {
  useGetCuratedSpaceQuery,
  useUpdateCuratedSpaceMutation,
} from "./curation.queries.graphql.generated";

export const EditCuration = () => {
  const { curationId } = useParams();

  const enableCuratedSpacesAuthor = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_CURATED_SPACES_AUTHOR
  );

  const { data: curatedSpaceData, loading: curatedSpaceLoading } =
    useGetCuratedSpaceQuery({
      variables: {
        getCuratedSpaceId: curationId!,
      },
      skip: curationId == null,
      fetchPolicy: "network-only",
    });

  const [updateCuratedSpace] = useUpdateCuratedSpaceMutation();

  if (enableCuratedSpacesAuthor === false) {
    return <Box>Curated Spaces are coming soon!</Box>;
  }

  if (curatedSpaceLoading) {
    return <Box>Loading...</Box>;
  }

  const curatedSpace = curatedSpaceData?.getCuratedSpace;
  if (curatedSpace == null || curatedSpace.draft == null) {
    return <Box>Error loading curated space</Box>;
  }

  const projectData = JSON.parse(curatedSpace.draft.projectData ?? "null");
  return (
    <>
      <AppSEO title="Edit Curation" />

      <ClientOnly>
        <MantineProvider theme={lightTheme} inherit withCSSVariables>
          <Box
            sx={{
              height: "100dvh",
              maxHeight: "100dvh",
              minHeight: "100dvh",
              width: "100%",
              maxWidth: "100%",
              minWidth: "100%",
              "--var-builder-panel-color": "var(--mantine-color-white)",
            }}
          >
            <Stack h={"100%"} w={"100%"} spacing={0}>
              <Box h={56}>
                <Link to={TOOLS_URL.curations.list}>
                  <Button
                    color={SECONDARY_COLOR}
                    leftIcon={<ArrowLeft height={12} />}
                  >
                    Back
                  </Button>
                </Link>
              </Box>
              <Box h={"100%"} mah={"calc(100% - 56px)"}>
                <CurationBuilder
                  initialProjectData={projectData}
                  onSetHtml={(html) => {
                    console.log("html", html);
                  }}
                  onSave={async ({ css, html, data }) => {
                    console.log("Save", { css, html, data });
                    try {
                      await updateCuratedSpace({
                        variables: {
                          updateCuratedSpaceId: curationId!,
                          data: {
                            css,
                            html,
                            projectData: JSON.stringify(data),
                            editorVersion: JSON.stringify({
                              version: BUILDER_VERSION,
                              timestamp: new Date().toISOString(),
                            }),
                            metadata: {
                              name: curatedSpace.metadata?.name ?? "Untitled",
                              description:
                                curatedSpace.metadata?.description ??
                                "A curated space",
                            },
                          },
                        },
                      });

                      console.log("Saved");
                      alert("Saved!");
                    } catch (error) {
                      console.error("Error saving curation", error);
                    }
                  }}
                  onShowPreview={() => {
                    console.log("Show Preview");
                    window.open(
                      window.location.href.replace("/edit", "/preview"),
                      "_blank"
                    );
                  }}
                />
              </Box>
            </Stack>
          </Box>
        </MantineProvider>
      </ClientOnly>
    </>
  );
};
